export default __webpack_public_path__ + "static/media/aler-tcon.4dc65111.png";